import type React from "react";

export function BankNote01Icon({
  className,
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={className}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5 9.1667V12.5M15 7.5V10.8333M14.1667 3.3333C16.2073 3.3333 17.311 3.6456 17.8601 3.8879C17.9333 3.9201 17.9698 3.9363 18.0754 4.037C18.1386 4.0974 18.2541 4.2745 18.2838 4.3568C18.3334 4.494 18.3334 4.569 18.3334 4.719V13.676C18.3334 14.4333 18.3334 14.8119 18.2198 15.0066C18.1043 15.2045 17.9929 15.2966 17.7766 15.3727C17.5641 15.4475 17.135 15.365 16.2768 15.2001C15.6762 15.0847 14.9638 15 14.1667 15C11.6667 15 9.1667 16.6667 5.8334 16.6667C3.7928 16.6667 2.6891 16.3544 2.1399 16.1121C2.0668 16.0799 2.0302 16.0638 1.9247 15.963C1.8614 15.9027 1.746 15.7255 1.7162 15.6433C1.6667 15.5061 1.6667 15.4311 1.6667 15.2811L1.6667 6.3241C1.6667 5.5667 1.6667 5.1881 1.7803 4.9935C1.8958 4.7955 2.0072 4.7034 2.2234 4.6274C2.436 4.5526 2.865 4.635 3.7232 4.7999C4.3239 4.9153 5.0363 5 5.8334 5C8.3334 5 10.8334 3.3333 14.1667 3.3333ZM12.0834 10C12.0834 11.1506 11.1506 12.0833 10 12.0833C8.8494 12.0833 7.9167 11.1506 7.9167 10C7.9167 8.8494 8.8494 7.9167 10 7.9167C11.1506 7.9167 12.0834 8.8494 12.0834 10Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.66667"
      />
    </svg>
  );
}
